import { useState } from 'react';
import DocumentsHeader from './DocumentsHeader';
import DocumentsTable from './DocumentsTable';
import UploadDocumentDialog from './UploadDocumentDialog';

function Documents() {
	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const handleOpenDialog = () => {
		setIsDialogOpen(true);
	};

	const handleCloseDialog = () => {
		setIsDialogOpen(false);
	};

	return (
		<div className="flex flex-col min-w-0 flex-auto">
			<div className="flex-1">
				<div className="max-w-6xl mx-auto space-y-6">
					<div className="w-full h-full flex flex-col px-4">
						<DocumentsHeader onAddDocument={handleOpenDialog} />
						<DocumentsTable />
						<UploadDocumentDialog
							open={isDialogOpen}
							onClose={handleCloseDialog}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Documents;

